import {serialize} from '../../../util/api-adapter';
import {FetchMethodEnum} from '../../../util/fetch';
import {getCsrfHeaders, mainApiHeaders, rootApiUrl} from '../../api/api-const';
import {ConcordanceAiPresetEnum} from '../review-analysis-ai-chat/review-analysis-ai-message-type';

// Matches the backend REVIEWS_SUMMARY_INSUFFICIENT_STATUS.
export const AI_SUMMARY_INSUFFICIENT_STATUS = 'insufficient_data';
export const AI_SUMMARY_QUOTA_STATUS_CODE = 412;
// The internal reviews-comments endpoint expects YYYY-MM-DD (GeneralParamsModel).
const DATE_ONLY_LENGTH = 10;

type AiSummaryPayloadType = {
    channelId: string;
    requestId: string;
    filterKey: string;
    presetKey: ConcordanceAiPresetEnum;
    searchParams: {
        startDate: string | null;
        endDate: string | null;
        companyId?: number;
        aspectIds?: Array<number>;
    };
};

// null => 204 (summary is streaming over Centrifugo); {status} => 200 (e.g. insufficient_data).
export async function requestReviewAnalysisAiSummary(payload: AiSummaryPayloadType): Promise<{status?: string} | null> {
    const {searchParams, filterKey, ...restPayload} = payload;
    const url = `${rootApiUrl}/cp/reviews_analytics/rocket_gpt/`;

    const response = await fetch(url, {
        method: FetchMethodEnum.post,
        credentials: 'include',
        headers: {...mainApiHeaders, ...getCsrfHeaders()},
        body: JSON.stringify(
            serialize({
                searchParams: {
                    ...searchParams,
                    startDate: searchParams.startDate?.slice(0, DATE_ONLY_LENGTH) ?? null,
                    endDate: searchParams.endDate?.slice(0, DATE_ONLY_LENGTH) ?? null,
                },
                filterKey,
                ...restPayload,
            })
        ),
    });

    if (response.status === AI_SUMMARY_QUOTA_STATUS_CODE) {
        const quotaError = new Error('rocket-gpt-quota-exceeded') as Error & {statusCode: number};

        quotaError.statusCode = AI_SUMMARY_QUOTA_STATUS_CODE;
        throw quotaError;
    }

    if (!response.ok) {
        throw new Error('review-analysis-ai-summary-request-failed');
    }

    if (response.status === 204) {
        return null;
    }

    return response.json();
}
